import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useToken } from 'native-base';
import { ADCPicker, DEFAULT_PICKER_ITEM_HEIGHT, DEFAULT_PICKER_VISIBLE_ITEMS, } from '../atoms';
const styles = StyleSheet.create({
    selectedView: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    viewArea: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },
    pickerContainer: {
        paddingHorizontal: 0,
    },
    divider: {
        alignContent: 'center',
        justifyContent: 'center',
    },
    label: {
        flex: 1,
    },
});
export const ADCMultiPicker = ({ containerStyles, divider, height = DEFAULT_PICKER_ITEM_HEIGHT, hideLabels = false, leftLabel, pickers, rightLabel, selectedOutline, testID = '', visibleItems = DEFAULT_PICKER_VISIBLE_ITEMS, }) => {
    // design tokens
    const labelSpacing = useToken('sizes', 2);
    return (React.createElement(View, { testID: `${testID}-multi-picker`, style: [
            styles.viewArea,
            {
                height: height * visibleItems,
                paddingHorizontal: labelSpacing,
            },
            containerStyles,
        ] },
        selectedOutline && (React.createElement(View, { testID: `${testID}-multi-picker-selected-outline`, style: [StyleSheet.absoluteFill, styles.selectedView] }, selectedOutline)),
        !hideLabels && (React.createElement(View, { testID: `${testID}-multi-picker-left-label`, style: [styles.label, { marginHorizontal: labelSpacing }] }, leftLabel)),
        pickers?.map((picker, index) => {
            return (React.createElement(React.Fragment, { key: `multi-picker-${index}` },
                React.createElement(ADCPicker, { testID: `${testID}-multi-picker-${picker.testID}-${index}`, items: picker.items, containerStyles: [styles.pickerContainer], disabled: picker.disabled, flatListStyles: [picker.flatListStyles], flatListContainerStyles: [picker.flatListContainerStyles], hideLabels: true, itemStyles: [picker.itemStyles], onChange: picker.onChange, selectedIndex: picker.selectedIndex, visibleItems: visibleItems, height: picker.height }),
                index < pickers.length - 1 && (React.createElement(View, { testID: `${testID}-multi-picker-divider-${index}`, style: [
                        styles.divider,
                        {
                            height,
                            marginHorizontal: labelSpacing,
                        },
                    ] }, divider))));
        }),
        !hideLabels && (React.createElement(View, { testID: `${testID}-multi-picker-right-label`, style: [styles.label, { marginHorizontal: labelSpacing }] }, rightLabel))));
};
